/* eslint-disable no-restricted-syntax */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export const create_room_vote = createAsyncThunk(
  'VoteMachine/create_room_vote',
  async (params: any, store: any) => {
    const {room_id} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/room/create_room_vote',
      {room_id, ...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_room_vote_tool_config = createAsyncThunk(
  'VoteMachine/get_room_vote_tool_config',
  async (params: any, store: any) => {
    const {room_id} = store.getState().env.otherInfo
    const resp = await http.post(
      '/live/room/get_room_vote_tool_config',
      {room_id, ...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const get_room_vote_detail_by_vote_id = createAsyncThunk(
  'VoteMachine/get_room_vote_detail_by_vote_id',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/room/get_room_vote_detail_by_vote_id',
      {...params},
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  detail: any
  home: any
}

const initialState: InitialStateType = {
  detail: {},
  home: {},
}

export const VoteMachineSlice = createSlice({
  name: 'VoteMachine',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      get_room_vote_detail_by_vote_id.fulfilled,
      (state, action) => {
        Object.assign(state.detail, action.payload)
      }
    )
    builder.addCase(get_room_vote_tool_config.fulfilled, (state, action) => {
      Object.assign(state.home, action.payload)
    })
  },
})
export default VoteMachineSlice.reducer
export const VoteMachineActions = VoteMachineSlice.actions

export const useVoteMachineState = () =>
  useSelector((store) => store.VoteMachine) as InitialStateType
